const required = (message = "Field is required") => (value: any) =>
  value ? undefined : message
export { required }
